<script setup>
import { reactive, ref } from 'vue';

const props = defineProps({
  ratingResult: Number,
  ratingStatus: Boolean,
});

const emit = defineEmits(['postRate']);

const starItem = reactive([
  { id: 1, active: false },
  { id: 2, active: false },
  { id: 3, active: false },
  { id: 4, active: false },
  { id: 5, active: false },
]);

const submitMessage = {
  1: '더 노력하는 낭만만세력이 되겠습니다. 😥',
  2: '부족한 부분을 개선하겠습니다. 소중한 의견 감사합니다! 🙇‍♂️',
  3: '좋은 피드백 감사합니다! 더욱 발전하겠습니다. 💪',
  4: '만족하셨다니 기쁩니다! 더 나은 서비스로 보답하겠습니다. 😊',
  5: '감사합니다! 낭만 가득한 하루 되세요. 💖',
};

const hoverIndex = ref(0); // 마우스 오버된 별의 인덱스
const selectedIndex = ref(0); // 클릭된 별의 인덱스

watch(
  () => props.ratingResult,
  (newRating) => {
    selectedIndex.value = newRating;
  },
  { immediate: true },
);

const postRate = () => emit('postRate', selectedIndex.value);

const handleMouseOver = (index) => {
  if (selectedIndex.value !== 0) return;
  hoverIndex.value = index;
};

const handleMouseLeave = () => {
  hoverIndex.value = 0;
};

const handleClick = (index) => {
  if (selectedIndex.value === index) {
    selectedIndex.value = 0;
    return;
  }
  selectedIndex.value = index;
};

const confirmSurvey = () => {
  if (!props.ratingStatus) postRate();
};
</script>

<template>
  <div class="df-card white df-survey">
    <div class="header content_review_text_title">
      📃<br />이 콘텐츠에 대해 어떻게 생각하시나요?
    </div>

    <i
      class="df-survey__emoji content_review_image_emoji"
      :class="`rate${hoverIndex || selectedIndex}`"
    ></i>

    <div
      class="df-survey__star-container content_review_image_star_inactive"
      :class="{ disabled: ratingStatus }"
    >
      <button
        v-for="(item, index) in starItem"
        :key="item.id"
        @mouseover="handleMouseOver(index + 1)"
        @mouseleave="handleMouseLeave"
        @click="handleClick(index + 1)"
      >
        <i :class="['star', { active: (hoverIndex || selectedIndex) >= index + 1 }]"></i>
      </button>
    </div>
    <button
      v-if="ratingStatus === false"
      class="df-survey__confirm content_review_button_submit_active"
      :class="{ active: selectedIndex !== 0 }"
      @click="confirmSurvey"
    >
      평가하기
    </button>
    <div v-if="ratingStatus" class="df-survey__message">
      {{ submitMessage[selectedIndex] }}
    </div>
  </div>
</template>

<style scoped>
.df-survey {
  min-height: 250px;
  justify-content: center;
  align-items: center;

  .header {
    height: auto;
  }

  .df-survey__emoji {
    width: 40px;
    height: 40px;
    background-size: cover;
  }
  .df-survey__emoji.rate0 {
    background: url(/src/assets/images_manse/emoji/rate3_soso.svg) no-repeat center center;
    background-size: cover;
  }
  .df-survey__emoji.rate1 {
    background: url(/src/assets/images_manse/emoji/rate1_sad.svg) no-repeat center center;
    background-size: cover;
  }
  .df-survey__emoji.rate2 {
    background: url(/src/assets/images_manse/emoji/rate2_bad.svg) no-repeat center center;
    background-size: cover;
  }
  .df-survey__emoji.rate3 {
    background: url(/src/assets/images_manse/emoji/rate3_soso.svg) no-repeat center center;
    background-size: cover;
  }
  .df-survey__emoji.rate4 {
    background: url(/src/assets/images_manse/emoji/rate4_good.svg) no-repeat center center;
    background-size: cover;
  }
  .df-survey__emoji.rate5 {
    background: url(/src/assets/images_manse/emoji/rate5_verygood.svg) no-repeat center center;
    background-size: cover;
  }

  .df-survey__star-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 8px;
  }
  .df-survey__star-container.disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  i.star {
    display: flex;
    width: 24px;
    height: 24px;
    mask: url('/src/assets/images_manse/icon_bookmark.svg') no-repeat center;
    background-color: #ebebeb;
    transition: background-color 0.2s ease;
  }

  i.star.active {
    background-color: #fbdb68;
  }

  .df-survey__confirm {
    display: flex;
    padding: 10px 16px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 6px;
    background: var(--Gray-500, #949494);
    color: var(--gray-100-white, #fff);
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  .df-survey__confirm.active {
    background: var(--orange-300-main, #eb4c10);
  }

  .df-survey__message {
    width: 100%;
    display: flex;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background: var(--Gray-200, #f8f8f8);
    color: var(--Gray-700, #575757);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
  }
}
</style>
